import { connect } from 'react-redux';
import DriveItemDeleteButton from '../../../components/DriveItem/DeleteButton';
import { StoreState } from '../../../reducers';

const mapStateToProps = (state: StoreState) => {
	const {
		isDeletingAll,
		downloadGroups: {
			all: {
				isDownloading: isDownloadingAll
			},
			important: {
				isDownloading: isDownloadingImportant
			}
		}
	} = state.downloadManager;

	const isDownloadingGroup = isDownloadingAll || isDownloadingImportant;

	return { isDeletingAll, isDownloadingGroup };
};

export default connect(mapStateToProps)(DriveItemDeleteButton);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/DeleteButton/index.tsx